import {
  FormControl,
  InputLabel,
  MenuItem,
  SelectChangeEvent,
} from "@mui/material";
import { useSearchContext } from "../../../contexts/SearchContext";
import { useCategories } from "../../../hooks/queries/useCategories";
import { FilterSelect } from "./FilterSelect";

const FilterCategoryGroup = () => {
  const {
    searchProductType,
    searchCategoryGroup,
    setSearchCategoryGroup,
    setSearchCategory,
  } = useSearchContext();
  const { data: categories = [] } = useCategories();

  const categoriesGroup = Object.keys(
    categories
      .filter(category => category.cod_type === searchProductType)
      .reduce<Record<string, string[]>>((acc, category) => {
        if (!acc[category.group]) {
          acc[category.group] = [];
        }

        const group = category.group;
        if (group) {
          acc[group]!.push(category.category);
        }

        return acc;
      }, {})
  );

  const onChange = (event: SelectChangeEvent<string>) => {
    const value = event.target.value !== "0" ? event.target.value : "*";

    setSearchCategoryGroup(value);
    setSearchCategory("*");
  };

  return (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel>Grupo Categoria:</InputLabel>
      <FilterSelect
        value={searchCategoryGroup}
        onChange={onChange}
        label="Grupo Categoria"
      >
        <MenuItem value="*">Todos os níveis</MenuItem>
        {categoriesGroup.map(category => (
          <MenuItem
            key={category}
            value={category}
            selected={searchCategoryGroup === category}
          >
            {category}
          </MenuItem>
        ))}
      </FilterSelect>
    </FormControl>
  );
};

export default FilterCategoryGroup;
